import { toBlob } from 'html-to-image';

/** Elements marked with this attribute are left out of the screenshot — the floating button. */
export const FEEDBACK_SCREENSHOT_IGNORE = 'data-feedback-ignore';

/**
 * "צרף צילום מסך של העמוד" — the page as it looks right now, as a PNG.
 *
 * Taken when the form opens and **before** it renders, so the form itself is not in the picture.
 * Fonts are skipped: embedding them is most of the cost and the text renders in the system font
 * just as legibly. An image that cannot be read (another origin without CORS) becomes a blank tile
 * rather than failing the whole capture. Any failure answers null — the request is still filed,
 * without the screenshot, and the checkbox says so.
 */
export const captureScreenshot = async (): Promise<Blob | null> => {
  try {
    return await toBlob(document.body, {
      pixelRatio: Math.min(window.devicePixelRatio || 1, 1.5),
      skipFonts: true,
      cacheBust: true,
      imagePlaceholder: 'data:image/gif;base64,R0lGODlhAQABAAAAACw=',
      filter: node => !(node instanceof HTMLElement && node.hasAttribute(FEEDBACK_SCREENSHOT_IGNORE))
    });
  } catch {
    return null;
  }
};
